import httpClient, { catchError } from '@emmacare/common/api/httpClient'

import { setReferralPayerList } from 'src/store/modules/admin'

import { REFERRAL_PAYER_GET_LIST } from 'src/constants'

// TODO
// this is only for consistency with class components, prefer useReferralPayer

export const fetchReferralPayerList =
  (config = {}) =>
  async (dispatch) => {
    try {
      const { items = [], meta = {} } = await httpClient.request({
        method: 'get',
        url: {
          pathname: REFERRAL_PAYER_GET_LIST,
          ...config
        }
      })

      dispatch(setReferralPayerList(items))

      return meta
    } catch (err) {
      catchError(err)
    }
  }
